<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit File :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <a href="javascript:void(0)" v-on:click="routerBack()">
                            <i class="fa fa-caret-left"></i> Back to Previous
                        </a>
                    </li>
                    <li class="breadcrumb-item active">Edit File</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-6 col-md-12 col-12">
                    <img :src="fileData" :style="imgStyles" />
                </div>
                <div class="col-lg-3">
                    <label>Rotate Degrees:</label>
                    <div class="form-group">
                        <input type="number" v-model="rotation" :min="0" :max="360" class="form-control" />
                        <span class="text-muted">Enter a number between 0 and 360</span>
                    </div>
                    <button class="btn btn-sm btn-success" v-on:click="saveFile()" :disabled="saving">
                        <template v-if="saving">Saving...</template>
                        <template v-else>Save Image</template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                userTimezone: this.$store.state.user.timezone,
                file_id: this.$route.params.id,
                file: null,
                fileData: null,
                rotation: 0,
            }
        },

        computed: {

            previousRoute(){
                //Setup
                var url = document.referrer.replace(process.env.MIX_BASE_URL, '');

                //Send it
                return url;
            },

            imgStyles(){
                //Setup
                var payload = {
                    'transform': 'rotate('+this.rotation+'deg)',
                    '-webkit-transform': 'rotate('+this.rotation+'deg)',
                    '-ms-transform': 'rotate('+this.rotation+'deg)',
                };

                //Send it
                return payload;
            }

        },

        methods: {

            getFile(){
                //Send it
                this.$http.get('files/edit/'+this.file_id)
                    .then(response => {
                        //Setter
                        this.file = response.data.file;
                        this.fileData = response.data.fileData;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    })
                    .then(() => {
                        //Helper
                        this.loading = false;
                    });
            },

            saveFile(){
                //Build the payload
                var payload = {
                    rotation: this.rotation,
                };

                //Helper Flag
                this.saving = true;

                //Send it
                this.$http.post('/files/edit/'+this.file_id, payload)
                    .then(res => {
                        //Alert the user
                        this.$toastr.success('File Updated');
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                break;
                        }
                    })
                    .then(() => {
                        //Helper
                        this.saving = false;
                    });
            },

            routerBack(){
                this.$router.go(-1);
            }

        },

        mounted() {
            //Get the file
            this.getFile();
        }
    }
</script>
